"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapSubjectSingleProductMultipleGifts;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _createSubjectIndirectSubjectsMultiple = _interopRequireDefault(require("../createSubjectIndirectSubjectsMultiple"));

/*
settings  - list of gifts or part inside product object:
[
  [
    giftProduct, // product id or sku or product object
    giftQuantity, // number of gifts per subject
    price, // gift price
    giftPriceOption // fixedSubjectPrice or other options
  ],
  ...
]
*/
function mapSubjectSingleProductMultipleGifts(_x, _x2, _x3, _x4) {
  return _mapSubjectSingleProductMultipleGifts.apply(this, arguments);
}

function _mapSubjectSingleProductMultipleGifts() {
  _mapSubjectSingleProductMultipleGifts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(ctx, rule, subject, settings) {
    var quantity, gifts, fixedPriceCond, result;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            (0, _invariant.default)(typeof settings === 'string' || Array.isArray(settings), 'createSubjectIndirectSubjectsMultiple requires settings to be type of `string` or `array` of gifts.');
            quantity = subject.quantity; // load settings from product price extensions

            gifts = (typeof settings === 'string' ? (0, _get.default)(settings, subject) : settings) || [];
            fixedPriceCond = (0, _cond.default)([[function (x) {
              return typeof x === 'boolean';
            }, function (x) {
              return x;
            }], [function (x) {
              return x === 'fixedSubjectPrice';
            }, function () {
              return true;
            }], [function () {
              return true;
            }, function () {
              return false;
            }]]);
            _context.next = 6;
            return (0, _createSubjectIndirectSubjectsMultiple.default)(ctx, rule, gifts.map(function (_ref) {
              var _ref2 = (0, _slicedToArray2.default)(_ref, 4),
                  giftProduct = _ref2[0],
                  giftQuantity = _ref2[1],
                  price = _ref2[2],
                  giftPriceOption = _ref2[3];

              return {
                product: giftProduct,
                quantity: giftQuantity * quantity,
                price: price,
                fixedPrice: fixedPriceCond(giftPriceOption)
              };
            }));

          case 6:
            result = _context.sent;
            return _context.abrupt("return", (0, _extends2.default)({}, result));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mapSubjectSingleProductMultipleGifts.apply(this, arguments);
}